export default __webpack_public_path__ + "static/media/pc_background_addtext.e598a531.png";